import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { useConfig } from "../_util/use-config";
export function Level(_a) {
    var _b = _a.startFlex, startFlex = _b === void 0 ? "none" : _b, _c = _a.endFlex, endFlex = _c === void 0 ? "none" : _c, _d = _a.startWidth, startWidth = _d === void 0 ? "auto" : _d, _e = _a.endWidth, endWidth = _e === void 0 ? "auto" : _e, start = _a.start, end = _a.end, children = _a.children, className = _a.className, props = __rest(_a, ["startFlex", "endFlex", "startWidth", "endWidth", "start", "end", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    var startStyle = {};
    var endStyle = {};
    if (startFlex && typeof startFlex === "string") {
        Object.assign(startStyle, { flex: startFlex });
    }
    if (startWidth !== "auto") {
        Object.assign(startStyle, {
            flexBasis: typeof startWidth === "number"
                ? pxTransform(startWidth, 750)
                : startWidth,
        });
    }
    if (endFlex && typeof endFlex === "string") {
        Object.assign(endStyle, { flex: endFlex });
    }
    if (endWidth !== "auto") {
        Object.assign(endStyle, {
            flexBasis: typeof endWidth === "number" ? pxTransform(endWidth, 750) : endWidth,
        });
    }
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-level", className) }, props),
        React.createElement(View, { className: classPrefix + "-level__start", style: startStyle }, start),
        React.createElement(View, { className: classPrefix + "-level__center" }, children),
        React.createElement(View, { className: classPrefix + "-level__end", style: endStyle }, end)));
}
//# sourceMappingURL=Level.js.map